/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback, memo } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { openDialog } from '../../../../app/dialog/dialog.actions';
import { WidgetKpi } from '../../common/widgets/widgets-kpi/WidgetKpi';
import { WidgetWrapper } from '../../common/widgets/WidgetWrapper';
import { IKpiProps } from './types';
import { fetchKpi } from '../../../../app/page/page-storage/kpi/kpi.actions';
import 'react-datepicker/dist/react-datepicker.css';
import { MeetingSelect } from '../../common/native-inputs/MeetingsSelect';
import PeriodAndCustomDateRangeFilters from '../../common/filters/PeriodAndCustomDateRangeFilters';
import { IKpiSearchParams } from '../../../../app/page/page-storage/kpi/kpi.types';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { meetingSimpleSelectors } from '../../../../app/resource/meeting-simple/meeting-simple.selectors';

export const Kpi: FunctionComponent<IKpiProps> = memo(({ meetingId, changeMeetingId, userId }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const meeting = useSelectWithParams(meetingSimpleSelectors.selectResourceById, meetingId);
  const goToScoreSettings = useCallback(() => history.push(`/kpi/${meetingId}`), [history, meetingId]);

  const openScoreFormDialog = useCallback(() => {
    dispatch(
      openDialog('scoreFormDialog', {
        meetingId,
      }),
    );
  }, [dispatch, meetingId]);

  const fetchKpisCallback = useCallback(
    (params?: IKpiSearchParams) => {
      dispatch(fetchKpi(meetingId, params));
    },
    [meetingId, dispatch],
  );

  return (
    <div id="kpi">
      <WidgetWrapper
        name={changeMeetingId ? "My KPI's" : "KPI's"}
        actionElement={
          <div
            className={`flex ${changeMeetingId ? 'justify-between' : 'justify-end'} align-center`}
            style={{ flexGrow: 1, height: '100%' }}
          >
            {changeMeetingId && <MeetingSelect onChange={changeMeetingId} style={{ height: 32 }} className="mx-2" />}
            <div className="flex align-center" style={{ height: 32 }}>
              <a
                className="btn btn-md popup_button"
                data-popup="new_score_popup"
                title="Add Score"
                onClick={openScoreFormDialog}
              >
                <i className="icon-plus mr-1"></i> Add Score
              </a>
              <a className="btn btn-md btn-border white-bg" title="Scorecard Settings" onClick={goToScoreSettings}>
                <i className="icon-settings mr-1 f-0 blueGray"></i> Scorecard Settings
              </a>
              <PeriodAndCustomDateRangeFilters callback={fetchKpisCallback} pageInProgressKey="fetchKpisApi" />
            </div>
          </div>
        }
      >
        <WidgetKpi meetingId={meetingId} kpisGroupedByUser={meeting?.kpisGroupedByUser ?? false} userId={userId} />
      </WidgetWrapper>
    </div>
  );
});
